import React from "react";

import ContentAdminQuestao from "./ContentAdminQuestao";

const AdminQuestao = () => {
  return (
    <>
      <ContentAdminQuestao />
    </>
  );
};

export default AdminQuestao;